import { useState } from "react";
import DOMPurify from 'dompurify'
import { marked } from "marked";


const TestPage = () => {

    const [text, setText] = useState("")

    const renderText = text => {
        let text2 = DOMPurify.sanitize(text, {ALLOWED_TAGS: ['b','h1','h2','h3','h4','h5','h6','div','strong','em','i','ul','li','a','p','table','tr','th','td','thead','tbody','tfoot','br','hr']})
        return marked.parse(text2)
    }

    const handleChange = (event) => {
        const text = event.target.value
        setText(text)
    }

    return ( 
        <div className="slide" id="testeur">
            <div className="gauche">
                <div className="wrapper">
                    <h2>Plonge dans le code : HTML en action</h2>
                    <div className="test-text">
                    Le HTML, c’est l’outil de base pour créer <strong>des sites web</strong>. Avec cet <strong>éditeur interactif</strong>, écris ton code à gauche et vois directement le résultat à droite. Simple, rapide et franchement satisfaisant. 
                    </div>
                    <h3>Prêt-e à tester?</h3>
                    <div className="instruction">
                        <p>Dans la zone en dessous, tape ce code: </p>
                        <pre>
                            {"<h1>Hello World!</h1>\n"}
                            {"<p>Première étape: tu viens de coder ta toute première page!</p>"}
                        </pre>
                        <p id="regarde-droite">Regarde à droite, ton contenu prend forme en live! </p>
                        <p id="regarde-bas">Regarde en bas, ton contenu prend forme en live! </p>
                        <h3>Pas mal non?</h3>
                        <textarea 
                            value={text}
                            onChange={handleChange}
                            className="zone-code"></textarea>
                    </div>
                </div>
            </div>
            <div className="droite">
                <div className="wrapper">
                    <div className="content-render" dangerouslySetInnerHTML={{__html:renderText(text)}}></div>
                </div>
            </div>
        </div>
     );
}
 
export default TestPage;